var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"keyboard-svg-wrapper"},[_c('keyboard-svg',{class:_vm.classObj,attrs:{"width":null,"height":null,"viewBox":"0 0 277 95"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }